
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

// @ts-ignore
import { Chrome } from "vue-color";

@Component({
  components: { Chrome }
})
export default class VueColorWrapper extends Vue {
  @Prop({
    default: "#2277eeff"
  })
  value!: string;

  updateValue(newColor: { hex8: string }) {
    /* If it doesn't have a hex8 on it, wtf */
    if ("hex8" in newColor) {
      this.$emit("input", newColor.hex8);
    } else {
      console.log("what the fuck, color picker not giving a valid value");
      this.$emit("input", "#2277eeff");
    }
  }
}
